import { render } from "./HeadingInfo.vue?vue&type=template&id=2ffa4412"
import script from "./HeadingInfo.vue?vue&type=script&lang=js"
export * from "./HeadingInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__